import React from 'react';
import ReactTooltip from 'react-tooltip';

interface Props {
  buttonText: string,
  clickedButton: any,
  tooltipText: string,
}

class SurveyButton extends React.Component<Props, {}> {
  constructor(props) {
    super(props);
    this.clickedButton = this.clickedButton.bind(this);
  }

  componentDidMount() {
    ReactTooltip.rebuild();
  }

  clickedButton() {
    this.props.clickedButton();
  }

  render() {
    let { buttonText, tooltipText } = this.props
    return(
      <div
        className="cs-blue-gradient-btn cs-new-large-btn"
        onClick={this.clickedButton}
        data-tip={tooltipText}
        data-for="marquee-banner-tooltip"
        data-html={false}
      >
        <i className="fas fa-poll-h cs-white" />
        {buttonText}
      </div>
    );
  }
}

export default SurveyButton;
